export const LEGAL_CONFIG = {
  brandName: "Qubiq",
  websiteUrl: "https://qubiq.tv",
  companyName: process.env.REACT_APP_LEGAL_COMPANY_NAME || "Qubiq",
  legalForm:
    process.env.REACT_APP_LEGAL_COMPANY_FORM ||
    "Société par actions simplifiée",
  capital: process.env.REACT_APP_LEGAL_COMPANY_CAPITAL || "1 000,00 euros",
  registrationCity:
    process.env.REACT_APP_LEGAL_COMPANY_REGISTRATION_CITY || "Paris",
  registrationNumber:
    process.env.REACT_APP_LEGAL_COMPANY_REGISTRATION_NUMBER || "103 892 980",
  vatNumber:
    process.env.REACT_APP_LEGAL_COMPANY_VAT || "FR7501.103892980",
  address:
    process.env.REACT_APP_LEGAL_COMPANY_ADDRESS ||
    "47 rue Vivienne 75002 Paris",
  registrationDate:
    process.env.REACT_APP_LEGAL_REGISTRATION_DATE || "17/04/2026",
  companyDuration:
    process.env.REACT_APP_LEGAL_COMPANY_DURATION || "Jusqu'au 16/04/2125",
  fiscalYearClosing:
    process.env.REACT_APP_LEGAL_FISCAL_YEAR_CLOSING || "30 septembre",
  firstFiscalYearClosing:
    process.env.REACT_APP_LEGAL_FIRST_FISCAL_YEAR_CLOSING || "30/09/2027",
  euid:
    process.env.REACT_APP_LEGAL_COMPANY_EUID || "FR7501.103892980",
  domiciliationName:
    process.env.REACT_APP_LEGAL_DOMICILIATION_NAME || "Vivienne Domiciliation",
  domiciliationRegistrationNumber:
    process.env.REACT_APP_LEGAL_DOMICILIATION_RCS || "994 567 121",
  mainActivities:
    process.env.REACT_APP_LEGAL_MAIN_ACTIVITIES ||
    "La conception, le développement de logiciels et outils informatiques, ainsi que leur exploitation et maintenance. La régie publicitaire de médias, incluant la gestion des espaces publicitaires pour les médias, la presse, la télévision ou internet. La promotion d'entreprises, produits ou services en ligne, via les réseaux sociaux, la publicité sur internet et le référencement sur les moteurs de recherche. Le conseil en informatique, en programmation et en stratégie digitale, ainsi que la réalisation de prestations associées. Le conseil et l'assistance aux entreprises dans la gestion de leur image de marque et de leur réputation.",
  publicationDirector:
    process.env.REACT_APP_LEGAL_PUBLICATION_DIRECTOR || "Damien ISIDORE",
  contactEmail:
    process.env.REACT_APP_LEGAL_CONTACT_EMAIL || "contact@qubiq.games",
  privacyEmail:
    process.env.REACT_APP_LEGAL_PRIVACY_EMAIL || "contact@qubiq.tv",
  hostingCompany:
    process.env.REACT_APP_LEGAL_HOST_NAME || "OVHcloud, ",
  hostingAddress:
    process.env.REACT_APP_LEGAL_HOST_ADDRESS || "2 rue Kellermann, 59100 Roubaix (France)",
  analyticsProvider: "Google Analytics 4",
  analyticsMeasurementId:
    process.env.REACT_APP_GA_MEASUREMENT_ID || "G-J8YZSJE1T9",
};

export const LEGAL_LINKS = [
  {
    key: "terms",
    path: "/legal/terms",
    icon: "description",
    fallbackLabel: "Conditions d'utilisation",
  },
  {
    key: "legal",
    path: "/legal/mentions",
    icon: "gavel",
    fallbackLabel: "Mentions légales",
  },
  {
    key: "privacy",
    path: "/legal/privacy",
    icon: "shield",
    fallbackLabel: "Politique de confidentialité",
  },
  {
    key: "cookies",
    path: "/legal/cookies",
    icon: "cookie",
    fallbackLabel: "Politique des cookies",
  },
  {
    key: "moderation",
    path: "/legal/moderation",
    icon: "policy",
    fallbackLabel: "Règles de modération",
  },
];
